import type { FunctionComponent } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form } from "../../../components/ui/form";
import { Button } from "../../../components/ui/button";
import { FormInput } from "../../../components/form-components/form-input.components";
import { FormPhoneInput } from "../../../components/form-components/form-phone-input.components";
import { FormProfileImageUpload } from "../../../components/form-components/form-profile-image.components";
import { useUserStore } from "../../../store/user.store";

export const FormSchema = z.object({
	coverImage: z.array(z.instanceof(File)),
	fullName: z.string().min(3),
	email: z.string().email().optional(),
	phone: z.string().min(10).optional(),
});

const DashboardProfileCommonPartial: FunctionComponent = () => {
	const { user } = useUserStore();
	const form = useForm<z.infer<typeof FormSchema>>({
		resolver: zodResolver(FormSchema),
		defaultValues: {
			coverImage: [],
			fullName: user?.name || "",
			email: user?.email || "",
			phone: user?.phoneNumber || " ",
		},
	});

	function onSubmit(data: z.infer<typeof FormSchema>) {
		console.log(data);
	}

	const handleClearUpload = (field: keyof z.infer<typeof FormSchema>) => {
		form.setValue(field, []);
	};

	return (
		<div className="flex flex-col gap-8 px-8 pt-16 w-full h-full">
			<div className="flex justify-between items-center w-full">
				<p className="font-semibold text-2xl">Profile info</p>
				<Button
					className="bg-tertiarybuttonbg px-8 py-5 border border-border font-semibold text-md"
					disabled={!form.formState.isDirty} // Use formState.isDirty to track changes
					onClick={form.handleSubmit(onSubmit)}
				>
					Save changes
				</Button>
			</div>
			<Form {...form}>
				<form
					onSubmit={form.handleSubmit(onSubmit)}
					className="relative flex flex-col gap-8 w-full"
				>
					<FormProfileImageUpload
						form={form}
						name="coverImage"
						label="Cover image"
						onClick={() => handleClearUpload("coverImage")}
						onValueChange={(files) => form.setValue("coverImage", files)}
					/>

					<div className="flex justify-between items-center gap-8 w-full">
						<FormInput
							form={form}
							name="fullName"
							label="Full name"
							placeholder="Enter your full name"
							required={false}
							min={3}
							type="text"
						/>
						<FormInput
							form={form}
							name="email"
							label="Work email"
							placeholder="Enter your work email"
							required={false}
							min={3}
							disabled={true}
							type="email"
						/>
					</div>
					<div className="flex justify-between items-center gap-8 w-full">
						<FormPhoneInput
							form={form}
							name="phone"
							label="Phone number"
							placeholder="Enter your phone number"
							required={false}
							min={10}
							disabled={true}
						/>
						<div className="w-full" />
					</div>
				</form>
			</Form>
		</div>
	);
};

export default DashboardProfileCommonPartial;
